import { render, staticRenderFns } from "./SwitchPlanModal.vue?vue&type=template&id=16d33e2c&scoped=true"
import script from "./SwitchPlanModal.vue?vue&type=script&lang=js"
export * from "./SwitchPlanModal.vue?vue&type=script&lang=js"
import style0 from "./SwitchPlanModal.vue?vue&type=style&index=0&id=16d33e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d33e2c",
  null
  
)

export default component.exports